import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-top-events-show-more-less-button',
    templateUrl: './top-events-show-more-less-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopEventsShowMoreLessButtonComponent {
    @HostBinding('class') className = 'show-more-less-button';
    @HostBinding('class.expanded') get isExpanded(): boolean {
        return !this.showMore;
    }

    @HostListener('click')
    onClick(): void {
        this.showMoreClicked.emit(this.isExpanded);
    }

    @Input() currentLength: number;
    @Input() totalLength: number;
    @Output() showMoreClicked = new EventEmitter<boolean>();

    constructor(public sitecore: Sitecore) {}

    get showMore(): boolean {
        return this.currentLength < this.totalLength;
    }

    get remainingCounter(): number {
        return this.totalLength - this.currentLength;
    }
}
